// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"notification-circle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 6C9.79086 6 8 7.79086 8 10L8 12.5L7 14.5L7 16L11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L17 16L17 14.5L16 12.5L16 10C16 7.79086 14.2091 6 12 6Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 6C9.79086 6 8 7.79086 8 10L8 12.5L7 14.5L7 16L11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L17 16L17 14.5L16 12.5L16 10C16 7.79086 14.2091 6 12 6Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}}]}]};

const NotificationCircleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'notification-circle',
    ref,
    icon: element,
  },
));

NotificationCircleIcon.displayName = 'NotificationCircleIcon';

export default NotificationCircleIcon;
